import { Suspense } from 'react';

import { BpkProvider } from '@skyscanner-internal/backpack-web/bpk-component-layout';
import ErrorBoundary from '@web-platform/shared-universal-ui-error-boundary';
import { isAcornRequest } from '@web-platform/shared-universal-utils-frontend/src/helpers/isAcornRequest';
import { lazyWithRetry } from '@web-platform/shared-universal-utils-frontend/src/helpers/lazyLoading';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { ConditionalTrackingProvider } from './ConditionalTrackingProvider';
import { Routes } from './Routes/Routes';

import type { StoreType } from '@web-platform/shared-universal-types/src/redux/state/state-shared-types';

type Props = {
  store: StoreType;
};

const GoneWrong = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "GoneWrong" */
      '@web-platform/shared-universal-features-components/src/GoneWrong/index'
    ),
);

export const App = ({ store }: Props) => {
  const isAcorn = isAcornRequest();

  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        componentName="App"
        fallback={
          <BpkProvider>
            <GoneWrong />
          </BpkProvider>
        }
      >
        <BpkProvider>
          {/* @ts-expect-error: The store uses different types for acorn/banana, suppressing TS error caused by the union type */}
          <Provider store={store}>
            <ConditionalTrackingProvider isAcorn={isAcorn}>
              <BrowserRouter
                future={{
                  v7_relativeSplatPath: true,
                  v7_startTransition: true,
                }}
              >
                <Routes />
              </BrowserRouter>
            </ConditionalTrackingProvider>
          </Provider>
        </BpkProvider>
      </ErrorBoundary>
    </Suspense>
  );
};
